import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "How quickly can my property be furnished?",
    a: "Our furniture partner, Your Property Furnished, can fully furnish your property within 7 working days anywhere on the UK mainland. Combined with Truestays' standard 7-day onboarding, most landlords are live on Airbnb within 2 weeks of signing up - making this the fastest route from an empty shell to an income-generating listing.",
  },
  {
    q: "Do I need to be at the property during installation?",
    a: "No. We coordinate all delivery, assembly and styling on your behalf. As long as we have access to the property, you don't need to be present at any point during the process.",
  },
  {
    q: "Can I choose my own style or furniture?",
    a: "Absolutely. You can choose from one of 12 pre-curated 2026 collections, or go fully bespoke with a tailored design service from £499 +VAT including detailed renders and a full inventory. Share floor plans, photos, or a walkthrough video and the design team will work to your brief and budget.",
  },
  {
    q: "What is included in a base furniture package?",
    a: "All packages include bedroom furniture (bed, mattress, wardrobe, bedside tables, bedding and linen), living/dining (sofa, dining table and chairs, coffee table, 43\" Smart TV, accessories), kitchen electricals (microwave, kettle, toaster, iron, vacuum, kitchen pack) and a complete bathroom accessories pack. Upgrades such as sofa beds, bar stools, dressing tables and outdoor furniture are available as additions.",
  },
  {
    q: "Are there flexible payment options?",
    a: "Yes. You can purchase outright, use lease finance over 3–5 years, or choose a 60-day payment plan to protect your cash flow. Finance options are offered subject to status.",
  },
  {
    q: "Is the furniture covered by a warranty?",
    a: "Yes - all hard furniture is backed by a no-quibble 3-year warranty against manufacturing defects. It's built specifically for the demands of serviced accommodation and high-turnover rental environments.",
  },
  {
    q: "Can you manage my property after furnishing?",
    a: "Yes - this is the full Truestays service. After installation is complete, we onboard your property onto our management platform, create and optimise your listings across 16+ platforms, set up dynamic pricing, and handle all guest communication, housekeeping and maintenance going forward. One seamless handover.",
  },
];

export default function InteriorsFAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section style={{
      backgroundColor: "#fff",
      paddingTop: "clamp(60px, 7vw, 96px)",
      paddingBottom: "clamp(60px, 7vw, 96px)",
      paddingLeft: "clamp(20px, 5vw, 80px)",
      paddingRight: "clamp(20px, 5vw, 80px)",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 80, alignItems: "start" }} className="faq-grid">
          {/* Left */}
          <div style={{ position: "sticky", top: 100 }} className="faq-sticky-left">
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", marginBottom: 14, marginTop: 0 }}>FAQs</p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3vw, 40px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#1A1A1A", marginTop: 0, marginBottom: 16 }}>
              Common questions answered.
            </h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#666", lineHeight: 1.65, marginTop: 0 }}>
              If you don't see your question here, <a href="/support" style={{ color: "#1A1A1A", textDecoration: "none", fontWeight: 600 }}>get in touch</a> - we're happy to help.
            </p>
          </div>

          {/* Right - accordion */}
          <div>
            {faqs.map((faq, i) => (
              <div
                key={i}
                style={{ borderBottom: "1px solid #EBEBEB", paddingTop: 20, paddingBottom: 20 }}
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  style={{
                    width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer",
                    display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, textAlign: "left",
                  }}
                >
                  <span style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15, color: "#1A1A1A", lineHeight: 1.4 }}>{faq.q}</span>
                  <div style={{ flexShrink: 0, width: 24, height: 24, borderRadius: "50%", background: open === i ? "#112215" : "#F0F0F0", display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.2s" }}>
                    {open === i
                      ? <Minus size={12} color="#fff" strokeWidth={2.5} />
                      : <Plus size={12} color="#555" strokeWidth={2.5} />
                    }
                  </div>
                </button>
                {open === i && (
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#555", lineHeight: 1.7, margin: "14px 0 0 0" }}>
                    {faq.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .faq-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .faq-sticky-left { position: static !important; }
        }
      `}</style>
    </section>
  );
}